'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _decisivUiUtils = require('decisiv-ui-utils');

var _SelectableLi = require('../../elements/SelectableLi');

var _SelectableLi2 = _interopRequireDefault(_SelectableLi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  display: flex;\n  padding: ' + (0, _decisivUiUtils.px2rem)(5) + ' ' + (0, _decisivUiUtils.px2rem)(10) + ';\n  &:hover {\n    cursor: pointer;\n\n    a {\n      color: ' + theme.colors.base.linkHover + ';\n      text-decoration: underline;\n    }\n  }\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      linkHover: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

// these modifiers are passed down to ContainerSelectable
// and are not on the li element directly
var propTypes = {
  modifiers: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

var defaultProps = {
  modifiers: []
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Dropdown__ListItem', (0, _styledComponents2.default)(_SelectableLi2.default), styles, {
  defaultProps: defaultProps,
  propTypes: propTypes,
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/Dropdown/ListItem.js
// module id = 1648
// module chunks = 2